import React from 'react';
import PropTypes from 'prop-types';

class HorizontalScroll extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {};

  componentDidMount() {
    this.dragElement(
      document.getElementById('div-wrapper').children[0].children[0]
        .children[0],
    );
  }
  dragElement = elmnt => {
    let isDown = false;
    let startX;
    let scrollLeft;

    const onMouseLeave = () => {
      // stop moving when mouse button is released:
      elmnt.style.cursor = 'grab';

      isDown = false;
    };

    const onMouseUp = () => {
      // stop moving when mouse button is released:
      elmnt.style.cursor = 'grab';

      isDown = false;
    };
    const onMouseMove = e => {
      if (!isDown) {
        return;
      }
      e.preventDefault();
      const x = e.pageX - elmnt.offsetLeft;
      const walk = x - startX;
      elmnt.scrollLeft = scrollLeft - walk;
      // calculate the new cursor position:
    };
    const onMouseDown = e => {
      isDown = true;
      startX = e.pageX - elmnt.offsetLeft;
      scrollLeft = elmnt.scrollLeft;

      elmnt.style.cursor = 'grabbing';
      document.onmouseup = onMouseUp;
      document.onmouseleave = onMouseLeave;
      // call a function whenever the cursor moves:
      document.onmousemove = onMouseMove;
    };

    // otherwise, move the DIV from anywhere inside the DIV:
    elmnt.onmousedown = onMouseDown;
    elmnt.style.cursor = 'grab';
  };

  render() {
    return (
      <div id="div-wrapper" style={{ height: '100%' }}>
        {this.props.children}
      </div>
    );
  }
}

export default HorizontalScroll;



// WEBPACK FOOTER //
// ./src/components/horizontalScroll/HorizontalScroll.jsx